
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-time/overview",
      function () {
        return require("private-next-pages/real-time/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-time/overview"])
      });
    }
  